import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, Transition as _Transition, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59679dac"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar-logo-container", {'collapse':_ctx.collapse}]),
    style: _normalizeStyle({ backgroundColor: _ctx.sideTheme === 'theme-dark' ? _ctx.variables.menuBackground : _ctx.variables.menuLightBackground })
  }, [
    _createVNode(_Transition, { name: "sidebarLogoFade" }, {
      default: _withCtx(() => [
        (_ctx.collapse)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: "collapse",
              class: "sidebar-logo-link",
              to: "/"
            }, {
              default: _withCtx(() => [
                (_ctx.logo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.logo,
                      class: "sidebar-logo"
                    }, null, 8, _hoisted_1))
                  : (_openBlock(), _createElementBlock("h1", {
                      key: 1,
                      class: "sidebar-title",
                      style: _normalizeStyle({ color: _ctx.sideTheme === 'theme-dark' ? _ctx.variables.logoTitleColor : _ctx.variables.logoLightTitleColor })
                    }, _toDisplayString(_ctx.title), 5))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: "expand",
              class: "sidebar-logo-link",
              to: "/"
            }, {
              default: _withCtx(() => [
                (_ctx.logo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.logo,
                      class: "sidebar-logo"
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true),
                _createElementVNode("h1", {
                  class: "sidebar-title",
                  style: _normalizeStyle({ color: _ctx.sideTheme === 'theme-dark' ? _ctx.variables.logoTitleColor : _ctx.variables.logoLightTitleColor })
                }, _toDisplayString(_ctx.title), 5)
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ], 6))
}